import React, { useRef, useState, useEffect } from 'react'
import { leftMenuToggle, rightMenuToggle, settingMenuToggle } from 'store/actions/home'
import { addActiveCompanyData } from 'store/actions/user'
import { signout } from 'store/actions/login'
import { useActions } from '../../../../hooks/useActions'
import { useHistory, useLocation } from 'react-router-dom'
import { Button, Dropdown, Layout, Menu, Drawer, Collapse } from 'antd'
const { Panel } = Collapse

import CustomTooltip from 'components/Tooltip'

const { Header } = Layout

import logo2 from 'assets/images/logo-2.svg'
import { Link } from 'react-router-dom'
import { Logout } from '@mui/icons-material'

import {
  StarIco,
  StarGreenIco,
  DropdownIco,
  NotificationIco,
  SettingsIco,
  ArrowUpIco,
  ArrowDownIco,
} from '../../../../../modules/CustomIcons'

import { connect } from 'react-redux'

import CreateTemplate from './CreateTemplate'

import '../../../main.layout.scss'
import { MenuCloseIco, MenuOpenIco } from '../../../../../modules/CustomIcons'
import starblue from 'assets/images/icons/starblue.png'
import starstroke from 'assets/images/icons/starstroke.png'
import starhovered from 'assets/images/icons/starhovered.png'
import starwhite from 'assets/images/icons/starwhite.png'
import { getCurrentCompany } from '../../../../services/user'
import { setFavCompany } from '../../../../services/user'
import { settingsMenus } from '../../../../../root/Routes/Routes'

import { Scrollbar } from 'smooth-scrollbar-react'
import type { Scrollbar as BaseScrollbar } from 'smooth-scrollbar/scrollbar'
import langEn from 'assets/images/icons/en.png'
import langRu from 'assets/images/icons/ru.png'
import langAz from 'assets/images/icons/az.png'
import { GetLastLogin, getLastLoginList } from "../../../../services/Auth/GetLastLogin";
import { secureLocalStorageGet, secureLocalStorageSet } from '../../../../helpers'
// import { logoutService } from '../../../../services/login'
import i18next from 'i18next';
import { useTranslation } from 'react-i18next'
import { clearSalaryListFunc } from "store/actions/salary";
import useResponsiveWidth from 'hooks/useResponsiveWidth'


const MainHeader: React.FC<any> = ({ leftMenuStatus, rightMenuStatus, settingMenuStatus,  companyData, loading }) => {
  const { t } = useTranslation();
  const location = useLocation()
  const { leftMenuToggle, rightMenuToggle, settingMenuToggle, signout, addActiveCompanyData, clearSalaryListFunc } = useActions()
  const [menuItem, setMenuItem] = useState(getCurrentCompany()?.name)
  const [settingsDrawerVisible, setSettingsDrawerVisible] = useState(false)
  const scrollbar = useRef<BaseScrollbar | null>(null)
  const [open, setOpen] = useState<any>([0])
  const [favIndex, setFav] = useState(0)
  const [favItem, setFavItem] = useState(getCurrentCompany()?.customerNo)
  const [companyDataState, setCompanyData] = useState(getCurrentCompany())
  const [loginDates, setLoginDates] = useState<GetLastLogin[]>()
  const [loginDatesFirst, setLoginDatesFirst] = useState<GetLastLogin>()
  const [isOpenDropdown, setIsOpenDropdown] = useState(false)
  const responsiveWidth = useResponsiveWidth();

  const settingsMenus = [
    {
      label: t("settings.userProfile"),
      path: '/settings'
    },
    {
      label: t("login.changePasswordTitle"),
      path: '/settings/change_password'
    },
    // {
    //   label : 'Hesablar',
    //   path : '/settings/accounts'
    // },
    // {
    //   label : 'Vidjetlər',
    //   path : '/settings/widgets'
    // },
    // {
    //   label : 'Şirkətin profili',
    //   path : '/settings/company_profile'
    // }
    // {
    //   label : i18next.t("home.accounts"),
    //   path : '/settings/accounts'
    // },
    // {
    //   label : i18next.t("settings.widgets"),
    //   path : '/settings/widgets'
    // },
    // {
    //   label : i18next.t("settings.companyProfile"),
    //   path : '/settings/company_profile'
    // }
  ]
  const showHideDrawer = () => {
    // setSettingsDrawerVisible(!settingsDrawerVisible)
    settingMenuToggle()
    if(responsiveWidth <=992) {
      leftMenuToggle(true)
      rightMenuToggle(false)
    }
  }


  const settingsDrawerClose = () => {
    // setSettingsDrawerVisible(false)
    settingMenuToggle(false)
  }

  const history = useHistory()

  const handleLogout = async () => {
    await clearSalaryListFunc();
    // await logoutService().catch(() => {});
    signout(history)
  }

  const side_h_class = leftMenuStatus ? 'h_collapsed' : ''
  // let userData = localStorage.getItem('userData')
  let userData = secureLocalStorageGet('userData')


  const setFavCompanyData = async (e, index) => {

    e.stopPropagation()
    e.preventDefault()
    let customerNo = companyData.customers !== undefined
      ? companyData.customers.asanCustomerList[index].customerNo
      : companyData.customerNo
    setFavItem(customerNo)
    let postData = { customerNo: customerNo }
    let favData = await setFavCompany(postData)
    setFav(favData)
  }

  const getLastLoginDates = async () => {
    const data = await getLastLoginList();

    setLoginDates(old_data => data);
    setLoginDatesFirst(old_data => data.find((row, index) => index === 0));
  }

//   useEffect(() => {
//     const fetchCompanyData = async () => {
//       let postData = { customerNo: getCurrentCompany()?.customerNo }
//       addActiveCompanyData(postData)
//       // const companyData = await addActiveCompanyData(postData)
//       // setCompanyData(companyData)
//     }
//     //
//     if (!loading) {
//       fetchCompanyData();
//       // settingsDrawerClose();
//       // getLastLoginDates();
//     }


//     // if (!loading) {

//     //   // const fetchCompanyData = async () => {
//     //   //   let postData = {customerNo: getCurrentCompany()?.customerNo}
//     //   //   addActiveCompanyData(postData)
//     //   //   const companyData = await addActiveCompanyData(postData)
//     //   //   setCompanyData(companyData)
//     //   // }
//     //   // const userInfo = secureLocalStorageGet('currentCompany')
//     //   //JSON.parse(userData)?.customerData?.[1]
//     //   // localStorage.setItem(
//     //   //     'currentCompany',
//     //   //     JSON.stringify(userInfo)
//     //   // )
//     //   // console.log()
//     //   // setCompanyData(userInfo)
//     //   // fetchCompanyData();
//     //   setMenuItem((companyData && companyData.customerName) ? companyData.customerName : companyData)
//     //   settingsDrawerClose();
//     //   getLastLoginDates();
//     // }
//     // }, [location])
//   }, [1])

  useEffect(() => {
    if (!loading) {
      setMenuItem((companyData && companyData.customerName) ? companyData.customerName : companyData)
      settingsDrawerClose();
      getLastLoginDates();
    }
  }, [companyData, loading])

  const handleMenuItem = async ({ key }) => {
    event.stopPropagation()
    event.preventDefault()

    setIsOpenDropdown(false);
    const userInfo = userData?.customerData?.[key]
    // localStorage.setItem(
    //   'currentCompany',
    //   JSON.stringify(userInfo)
    // )
    secureLocalStorageSet('currentCompany', userInfo);
    let postData = { customerNo: userInfo['customerNo'], history: history }
    await clearSalaryListFunc();

    await addActiveCompanyData(postData)
  }

  const drop_down_menus = (
    <Menu
      style={{ width: 221 }}
      className="header-dropdown-menu companies_drop_down"
      onClick={handleMenuItem}
    >
      {userData &&
        userData?.customerData.map((item: object, index: number) => {
          return (
            <Menu.Item
              key={index}
              className={item.name == menuItem ? 'active' : ''}
            >
              {item.name.length > 38 ? (
                <CustomTooltip
                  className="header-dropdown-menu__tooltip"
                  placement="bottom"
                  title={item.name}
                >
                  <div>{item.name}</div>
                  {/* <Link to={'/'}>{item.name}</Link> */}
                </CustomTooltip>
              ) : (
                <div>{item.name}</div>
              )}
              <CustomTooltip
                className="header-dropdown-menu__tooltip"
                placement="topRight"
                title={t("home.determiningCompany")}
              >
                <Button
                  className='favourite-star'
                  onClick={(event) => setFavCompanyData(event, index)}
                  icon={
                    item.customerNo == favItem ? (
                      <StarGreenIco className="starIcoActive" />
                    ) : (
                      <StarIco className="startIcon" />
                    )
                  }
                />
                {/* <Link to={'/'}>{item.name}</Link> */}
              </CustomTooltip>

            </Menu.Item>
          )
        })}
    </Menu>
  )

  const collapseHeader = (text) => <p>{text}</p>

  const collapseExtra = () => <></>

  const rowClassName = (record, index) => {
    return `row_${index}`
  }

  const openCloseCollapse = () => {
    setOpen((prev) => (prev.indexOf(0) != -1 ? [1] : [0]))
  }

  const reloadPageLogo = () => {
    if (location.pathname === "/") {
      history.go(0)
    }
  }

  const dropDownVisibleChange = () => {
    setIsOpenDropdown(!isOpenDropdown);
  }

  const controlDropdownMenu = () => {
    setIsOpenDropdown(false);
  };

  useEffect(() => {
    const layoutScroll = document.getElementById("layout_scroll");
    if (typeof layoutScroll !== 'undefined') {
      layoutScroll?.addEventListener('scroll', controlDropdownMenu);

      return () => {
        layoutScroll?.removeEventListener('scroll', controlDropdownMenu);
      };
    }
  });

  const changeLangFunc = async (lang: string) => {
    // setSettingsDrawerVisible(false)
    settingMenuToggle(false)
    await i18next.changeLanguage(lang);
    localStorage.setItem('preferredLanguage', lang);
    history.go(0)
  }

  const lang = localStorage.getItem("i18nextLng")
  return (
    <>

      <Header className="flex align_center header" style={{ padding: 0 }}>
        <div className="header_right full_h flex justify_evenly align_center flex_1">
              <Button
                className="transparent"
                onClick={showHideDrawer}
                icon={<SettingsIco />}
              />

              <Button
                icon={<Logout />}
                onClick={() => handleLogout()}
                className="transparent"
              />
        </div>
      </Header>

      <Drawer
        title={false}
        placement="right"
        onClose={settingsDrawerClose}
        visible={settingMenuStatus}
        width={270}
        closable={false}
        className={'setting_drawer'}
      >
        <ul className="language_list flex justify_center full">
          {
            lang !== "az" ?
              <li>
                <Button type={'ghost'} className={'transparent flex align_center'} onClick={() => { changeLangFunc("az") }}>
                  <img src={langAz} />
                  <span>AZ</span>
                </Button>
              </li> : <></>
          }
          {
            lang !== "en" ?
              <li>
                <Button type={'ghost'} className={'transparent flex align_center'} onClick={() => { changeLangFunc("en") }}>
                  <img src={langEn} />
                  <span>EN</span>
                </Button>
              </li> : <></>
          }

          {
            lang !== "ru" ?
              <li>
                <Button type={'ghost'} className={'transparent flex align_center'} onClick={() => { changeLangFunc("ru") }}>
                  <img src={langRu} />
                  <span>RU</span>
                </Button>
              </li> : <></>
          }
        </ul>

        <Scrollbar
          ref={scrollbar}
          plugins={{
            disableScroll: { direction: 'x' },
          }}
          alwaysShowTracks={true}
          className={'full'}
        >
          <Collapse
            expandIcon={(panelProps) => (
              <Button
                type={'ghost'}
                className={'transparent'}
                // onClick={openCloseCollapse}
                icon={
                  panelProps.isActive ? (
                    <ArrowUpIco className={'cursor_pointer settings_drawer_arrow'} />
                  ) : (
                    <ArrowDownIco className={'cursor_pointer settings_drawer_arrow'} />
                  )
                }
              />
            )}
            activeKey={[open]}
            onChange={openCloseCollapse}
            expandIconPosition={'right'}
            className="login_history_collapse"
          >
            <Panel
              header={collapseHeader(t("settings.lastLogin"))}
              key="1"
              extra={collapseExtra()}
              collapsible={'header'}
            >
              <ul className={' flex direction_column login_history_list'}>
                {
                  loginDates?.map((row, index) => {
                    return (
                      <li key={index}>
                        <span className={'date_span'}>{row.LAST_LOGIN_DATE}</span>
                        <span className={'time_span'}>{row.LAST_LOGIN_TIME}</span>
                      </li>
                    )
                  })}
              </ul>
            </Panel>
          </Collapse>

          {open == 0 && (
            <ul
              className={
                ' flex direction_column login_history_list login_history_list_2'
              }
            >
              <li>
                <span className={'date_span'}>{loginDatesFirst?.LAST_LOGIN_DATE}</span>
                <span className={'time_span'}>{loginDatesFirst?.LAST_LOGIN_TIME}</span>
              </li>
            </ul>
          )}

          <ul
            className={
              'flex direction_column full settings_list setting_left_menus setting_top_right_menus'
            }
          >
            {settingsMenus?.map((item: object, index: number) => {
              return (
                <li key={index}>
                  <Link to={item.path} activeClassName={'active'} exact={true} onClick={() => responsiveWidth<= 992 && settingMenuToggle(false)}>
                    {t(item.label)}
                  </Link>
                </li>
              )
            })}
          </ul>
        </Scrollbar>
      </Drawer>
    </>
  )
}

const mapDispatchToProps = { leftMenuToggle, rightMenuToggle, settingMenuToggle, signout, addActiveCompanyData, clearSalaryListFunc }

const mapStateToProps = (state: any) => ({
  leftMenuStatus: state.home.leftMenuStatus,
  rightMenuStatus: state.home.rightMenuStatus,
  settingMenuStatus: state.home.settingMenuStatus,
  companyData: (state.user && state.user.companyData.result) ? state.user.companyData.result : state.user.companyData.name,
  loading: state.user.isCompChange
})


export default connect(mapStateToProps, mapDispatchToProps)(MainHeader)
